<div class="field-block" [class.field-block-full]="fullWidth">
  <label class="form-label" [for]="controlId">{{ labelKey | translate }}</label>

  <div class="date-input-wrapper">
    <input
      #dateInput
      class="form-control"
      [class.is-invalid]="invalid"
      [formControlName]="controlName"
      [id]="controlId"
      type="text"
    />
    <i class="fa-solid fa-calendar-days date-input-icon" aria-hidden="true"></i>
  </div>

  <ng-content />
</div>
